<template>
    <ayuda-tema-base
        :busqueda="busqueda"
        :color="color"
        :faqs="faqs"
    />
</template>

<script>
import AyudaTemaBase from './AyudaTemaBase.vue';

export default {
    name: 'AyudaTemaCuenta',
    components: {
        AyudaTemaBase
    },
    props: {
        busqueda: {
            type: String,
            default: ''
        },
        color: {
            type: String,
            default: '#EF6C00'
        }
    },
    computed: {
        faqs() {
            return [
                {
                    id: 1,
                    pregunta: this.$t('mensajes.central_reservas.ayuda_contenido.faqs.cuenta.1.pregunta'),
                    respuesta: this.$t('mensajes.central_reservas.ayuda_contenido.faqs.cuenta.1.respuesta')
                },
                {
                    id: 2,
                    pregunta: this.$t('mensajes.central_reservas.ayuda_contenido.faqs.cuenta.2.pregunta'),
                    respuesta: this.$t('mensajes.central_reservas.ayuda_contenido.faqs.cuenta.2.respuesta')
                },
                {
                    id: 3,
                    pregunta: this.$t('mensajes.central_reservas.ayuda_contenido.faqs.cuenta.3.pregunta'),
                    respuesta: this.$t('mensajes.central_reservas.ayuda_contenido.faqs.cuenta.3.respuesta')
                },
                {
                    id: 4,
                    pregunta: this.$t('mensajes.central_reservas.ayuda_contenido.faqs.cuenta.4.pregunta'),
                    respuesta: this.$t('mensajes.central_reservas.ayuda_contenido.faqs.cuenta.4.respuesta')
                },
                {
                    id: 5,
                    pregunta: this.$t('mensajes.central_reservas.ayuda_contenido.faqs.cuenta.5.pregunta'),
                    respuesta: this.$t('mensajes.central_reservas.ayuda_contenido.faqs.cuenta.5.respuesta')
                }
            ];
        }
    }
};
</script>
